import { render, staticRenderFns } from "./Last4Week.vue?vue&type=template&id=2142b88b&lang=pug"
import script from "./Last4Week.vue?vue&type=script&lang=js"
export * from "./Last4Week.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports